/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';

export default class ConversationController extends Controller {
  queryParams = [
    { previewSideConversation: 'preview_side_conversation' },
    { sidebarTab: 'sidebar_tab' },
  ];

  declare previewSideConversation?: string;
  declare sidebarTab?: string;
}
